import React, { useEffect, useRef } from "react";

const OtpInput = ({ length = 6, onChange }) => {
  const inputs = Array(length).fill(0);
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // Only digits
    if (value) {
      inputRefs.current[index].value = value[0];
      if (index < length - 1) inputRefs.current[index + 1].focus();
    }
    updateOtp();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length);

    for (let i = 0; i < paste.length; i++) {
      inputRefs.current[i].value = paste[i];
    }

    const nextIndex = Math.min(paste.length, length - 1);
    inputRefs.current[nextIndex].focus();
    updateOtp();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const updateOtp = () => {
    const otp = inputRefs.current.map((input) => input.value).join("");
    onChange(otp);
  };

  return (
    <div className="flex gap-2 justify-center">
      {inputs.map((_, index) => (
        <input
          key={index}
          type="text"
          inputMode="numeric"
          maxLength={1}
          className="w-12 h-12 sm:w-14 sm:h-14 text-center border border-gray-300 rounded text-lg font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
          ref={(el) => (inputRefs.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OtpInput;
